export const cainiaoColumns = {
    selection: false,
    height: 390,
    columns: [
        {
            label: '订单号',
            prop: 'orderNo',
            width: '160px',
            type: 'normal'
        },
        // {
        //     label: '期望送装类型',
        //     prop: 'expectInstallTypeName',
        //     width: '120px',
        //     type: 'normal'
        // },
        {
            label: '首约时间',
            prop: 'firstAppointmentTime',
            width: '194px',
            type: 'normal'
        },
        {
            label: '期望配送时间',
            prop: 'expectDeliveryTime',
            width: '194px',
            type: 'normal'
        },
        {
            label: '产品品类',
            prop: 'itemClassName',
            width: '210px',
            type: 'normal'
        },
        {
            label: '产品型号',
            prop: 'itemName',
            width: '290px',
            type: 'normal'
        }
        // {
        //     label: '期望安装时间',
        //     prop: 'expectInstallTime',
        //     width: '120px',
        //     type: 'normal'
        // }
    ]
};